import { render, staticRenderFns } from "./IvTypesPanel.vue?vue&type=template&id=677b0b5e&scoped=true&"
import script from "./IvTypesPanel.vue?vue&type=script&lang=js&"
export * from "./IvTypesPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "677b0b5e",
  null
  
)

export default component.exports